import { ADDRESSES, GRAPH_NODE_BASE_URL, STAKE_TOKEN, BASE_API_URL } from '@pancakeswap/address-config'

const launchpad = ADDRESSES

export const stakingPool = launchpad.StakingPool
export const idoPoolFactory = launchpad.IdoPoolFactory
export const insurancePool = launchpad.InsurancePool
export const scoreCalculator = launchpad.ScoreCalculator

export const stakeToken: string = STAKE_TOKEN
export const GraphNodeBaseUrl: string = GRAPH_NODE_BASE_URL
export const BaseApiUrl: string = BASE_API_URL
